import { connect } from 'react-redux';
import EmbeddedPlayer from '../../components/outputPlayer/EmbeddedPlayer.js';

const mapStateToProps = state => {
  return {
    autoplay: state.player.autoplay,
    containerId: state.player.containerId,
    name: state.player.name,
    version: state.player.version,
  };
};

const mapDispatchToProps = () => {
  return {};
};

const EmbeddedPlayerRedux = connect(mapStateToProps, mapDispatchToProps)(EmbeddedPlayer);

export default EmbeddedPlayerRedux;
